<template>
  <div class="mainPage">
    <div class="header_banner">
      <header>
        <div class="center">
          <div class="right">
            <div v-show="!isLogin" class="loginCon">
              <span @click="toLogin()">登录</span>
            </div>
            <div v-show="isLogin" class="loginCon">
              <span
                ><span class="username">{{ user.username }} </span> /
                <span @click="toLogOut()"> 退出</span>
              </span>
            </div>
          </div>
        </div>
      </header>
      <div class="infoCon">
        <div class="centerBg">
          <img src="../img/iccb/banner_title.png" alt="" class="left" />
        </div>
      </div>
    </div>
    <div class="content">
      <div class="rightBox">
        <div class="classBox">
          <!-- swiper1 -->
          <swiper
            v-if="courseList.length > 0"
            class="swiper gallery-top"
            :options="swiperOptionTop"
            ref="swiperTop"
          >
            <swiper-slide
              class="slide"
              v-for="(subject, index) in courseList"
              :key="subject.id"
            >
              <img class="leftImg" :src="subject.cover_url" alt="" />
              <div class="right">
                <p class="text1">第 {{ courseList.length - index }} 讲</p>
                <p class="courseName" v-html="subject.name"></p>
                <p class="teacherName"> 
                  授课老师：{{ subject.teacher_name }} ({{
                    subject.organization_name
                  }})
                </p>
                <p class="courseDec">{{ subject.extra.teacher_des }}</p>
                <div class="btnLearn" @click="replay(subject)">
                  <img src="../img/iccb/btn_icon.png" alt="" />
                  <span>开始学习</span>
                </div>
              </div>
            </swiper-slide>
            <!-- <div class="swiper-button-next swiper-button-white" slot="button-next"></div>
						<div class="swiper-button-prev swiper-button-white" slot="button-prev"></div> -->
          </swiper>
          <!-- swiper2 Thumbs -->

          <swiper
            v-if="courseList.length > 0"
            class="swiper gallery-thumbs"
            :options="swiperOptionThumbs"
            ref="swiperThumbs"
          >
            <swiper-slide
              class="slide"
              v-for="subject in courseList"
              :key="subject.id"
            >
              <img class="courseImg" :src="subject.cover_url" alt="" />
              <p class="courseName" v-html="subject.name"></p>
            </swiper-slide>
            <div
              class="swiper-button-next swiper-button-white"
              slot="button-next"
            ></div>
            <div
              class="swiper-button-prev swiper-button-white"
              slot="button-prev"
            ></div>
          </swiper>
        </div>
      </div>
    </div>

    <div class="footer" v-show="courseList.length > 0">
      <div class="copy">版权所有：© 中外语言交流合作中心</div>
    </div>

    <!-- 视频弹窗 -->
    <transition name="fade">
      <div id="videoPlayWrapper" v-if="isPlay" @mousewheel.prevent>
        <div class="videoContent">
          <div class="closeVideo" @click="closeVideo()">×</div>
          <div class="videoContainer">
            <!-- <ali-player
              ref="aliplayer"
              @play="play($event)"
              @pause="pause($event)"
              @ended="ended($event)"
              :autoplay="true"
              :isLive="false"
              :rePlay="false"
              :showBuffer="true"
              :preload="true"
              :useH5Prism="true"
              :playsinline="true"
              showBarTime="5000"
              width="100%"
              height="100%"
              controlBarVisibility="always"
              :encryptType="1"
              :progressMarkers="progressMarkers"
              :vid="currentVideo.video_id"
              :playauth="playAuth"
            >
            </ali-player> -->
						<TCPlayer :options="options" style="width: 100%; height: 100%"></TCPlayer>
          </div>
        </div>
      </div>
    </transition>

    <!-- 评分弹窗 -->
    <transition name="fade">
      <div id="rateWrapper" v-if="isRate && !isRated" @mousewheel.prevent>
        <div class="rateContent">
          <div class="closeRate" @click="closeRate()">×</div>
          <div class="rateContainer">
            <img src="../img/iccb/smile.png" alt="" class="smile" />
            <div class="title">为我们评分</div>
            <div class="subTitle">您的鼓励，是我们无限的动力~</div>
            <div class="text">1.您对该课程的内容是否满意？</div>
            <div><el-rate v-model="rate1"></el-rate></div>

            <div class="text2">2.您是否愿意再参与这样的线上课程？</div>
            <div><el-rate v-model="rate2"></el-rate></div>
            <div class="btnBox">
              <button class="btn" @click="submitRate()">确定</button>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <!-- 修改密码弹窗 -->
    <transition name="fade">
      <div id="tipsWrapper" v-if="isShowTips" @mousewheel.prevent>
        <div class="rateContent">
          <div class="closeRate" @click="closeTips()">×</div>
          <div class="rateContainer">
            <!-- <img src="../img/iccb/smile.png" alt="" class="smile" /> -->
            <div class="title">提醒</div>
            <!-- <div class="subTitle">您的鼓励，是我们无限的动力~</div> -->
            <div class="text">
              目前账号首次登录，初始密码为Abc@123456。为了保障您的账号安全，请及时修改个人登录密码。<br />
              <span style="color: #0e79c0"
                >（请点击新页面上的“忘记密码”修改）</span
              >
            </div>
            <div class="btnBox">
              <button class="btn" @click="closeTips()">确定</button>
              <button class="btn" @click="toEdit()">去修改</button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Qs from "qs";
import language from "./common/language";
import aliPlayer from "./common/aliplayer";
import TCPlayer from './common/TCPlayer'
export default {
  name: "chinesebridge",
  components: {
    language,
    aliPlayer,
		TCPlayer
  },
  metaInfo() {
    return {
      title: "“国际传播能力建设”在线培训课程",
      meta: [
        {
          name: "keyword",
          content: "国际传播能力建设”在线培训课程",
        },
        {
          name: "description",
          content:
            "培养具有国际传播视野和相应能力素养的国际中文教师、志愿者，在语合中心新闻处指导下，中文联盟拟为中心员工及公派教师、志愿者提供“国际传播能力建设”在线课程制作服务，旨在通过该课程，切实提高国际传播的实践应用能力，讲好国际中文教育故事。",
        },
      ],
    };
  },
  data: function () {
    return {
			options:{
				fileID: "",
				appID: "1500035244",
				autoplay: true,
				psign:"",
			},
      isChrome: true,
      isLogin: false,
      isAuth: false,
      isPlay: false,
      timer: null,
      isRate: false,
      isRated: true,
      rate1: 5,
      rate2: 5,
      scheduleTime: null,
      currentVideo: {},
      user: {
        username: "",
        email: "",
      },
      lang: "cn",
      active: 0,
      subject_info: [],
      courseList: {},
      subject_id: null,
      subject_name: [],
      subject_subText: [],
      // 播放权限
      playAuth: "",
      isShowTips: false,
      swiperOptionTop: {
        loop: false,
        loopedSlides: 5, // looped slides should be the same
        spaceBetween: 10,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      swiperOptionThumbs: {
        loop: false,
        loopedSlides: 5, // looped slides should be the same
        spaceBetween: 10,
        centeredSlides: true,
        slidesPerView: "auto",
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        touchRatio: 0.2,
        slideToClickedSlide: true,
      },
      progressMarkers: [],
    };
  },
  computed: {
    language() {
      return this.$i18n.locale;
    },
  },
  created() {
    //检查登录
    this.customCheckLogin();
    // 专题获取数据
    this.getSubjectInfo("iccb");
  },
  mounted() {
    this.checkChrome();
  },

  methods: {
    // 登录
    toLogin() {
      window.location.href =
        this.baseUrl +
        "user/api/login?" +
        "callback=" +
        encodeURIComponent(window.location.href);
    },
    // 注册
    toRegister() {
      window.location.href =
        "https://passport.chinesecio.com/static/frontend/dist/#/pc/register?callback=" +
        encodeURIComponent(window.location.href);
    },
    // 检查是否登录 获取用户信息
    customCheckLogin() {
      this.checkLogin()
        .then((res) => {
          if (res.data.success) {
            this.isLogin = true;
            this.user = res.data.data;
            this.checkAuth(res.data.data.email);
            if (localStorage.getItem("isShowTips") == "false") {
              this.isShowTips = false;
            } else {
              this.isShowTips = true;
            }
          } else {
            this.isLogin = false;
          }
        })
        .catch((r) => {
          console.log(r);
        });
    },

    // 退出登录
    toLogOut() {
      this.$utils.get("/user/api/logout").then((res) => {
        if (res.data.success) {
          this.isLogin = false;
        }
      });
    },

    // 判断权限
    checkAuth(email) {
      this.$utils
        .get("/user/api/checkuser", {
          email,
        })
        .then((res) => {
          this.isAuth = res.data;
        });
    },

    play(e, v) {
      this.scheduleTime = e.getCurrentTime() / e.getDuration();
    },
    pause(e, v) {
      this.scheduleTime = e.getCurrentTime() / e.getDuration();
      // 定时器记录视频播放进度
      this.getVideoSchedule();
    },
    ended(e, v) {
      this.scheduleTime = e.getCurrentTime() / e.getDuration();
      this.isRate = true;
      this.getVideoSchedule();
    },
    closeRate() {
      this.isRate = false;
    },
    closeTips() {
      this.isShowTips = false;
      localStorage.setItem("isShowTips", "false");
    },
    // 去修改密码
    toEdit() {
      this.isShowTips = false;
      localStorage.setItem("isShowTips", "false");
      window.location.href =
        "https://passport.chineseplus.net/static/frontend/dist/#/pc/auth_login?callback=" +
        encodeURIComponent(window.location.href);
    },
    submitRate() {
      this.$utils
        .post("/user/api/userScoreLog", {
          lesson_id: this.currentVideo.id,
          video_id: this.currentVideo.video_id,
          score_content: this.rate1,
          score_join: this.rate2,
        })
        .then((res) => {
          if (res.status == 200 && res.data) {
            this.$message({
              message: "评分成功",
              type: "success",
            });
          }
        })
        .catch((r) => {
          console.log(r);
        });

      // 关闭弹窗
      this.isRate = false;
    },
    // 记录视频播放进度
    getVideoSchedule() {
      this.$utils
        .post("/user/api/userViewLog", {
          lesson_id: this.currentVideo.id,
          video_id: this.currentVideo.video_id,
          schedule: this.scheduleTime.toFixed(2),
        })
        .then((res) => {})
        .catch((r) => {
          console.log(r);
        });
    },

    // 获取专题信息
    getSubjectInfo(alias) {
      this.$utils
        .get("/subject/subject/readbyalias", {
          alias,
        })
        .then((res) => {
          if (res.data.success) {
            this.subject_info = res.data.data;
            this.getCourseInfo(this.subject_info.id);
          }
        })
        .catch((r) => {
          console.log(r);
        });
    },

    // 通过专题ID信息 获取课程列表
    getCourseInfo(id) {
      this.$utils
        .get("/subject/lesson/getlist", {
          subject_id: id,
          limit: 999,
        })
        .then((res) => {
          //处理课程列表
          if (res.data.success) {
            this.courseList = res.data.data.list.reverse();
            // 课程列表倒叙
          }

          // 上下轮播图
          this.$nextTick(() => {
            const swiperTop = this.$refs.swiperTop.swiper;
            // console.log("swiperTop", this.$refs.swiperTop);
            const swiperThumbs = this.$refs.swiperThumbs.swiper;
            swiperTop.controller.control = swiperThumbs;
            swiperThumbs.controller.control = swiperTop;
          });
        })
        .catch((r) => {
          console.log(r);
        });
    },

    //播放课程
    async replay(data) {
      // 判断登录状态
      if (!this.isLogin) {
        this.$message({
          message: "请在登录后查看视频！",
          type: "warning",
        });
        return;
      }

      // 判断权限
      if (!this.isAuth) {
        this.$message({
          message: "当前账号没有观看权限！",
          type: "warning",
        });
        return;
      }
      this.currentVideo = data;

      // 获取是否评分
      this.$utils
        .get("/user/api/getUserScoreLog", {
          lesson_id: this.currentVideo.id,
          video_id: this.currentVideo.video_id,
        })
        .then((res) => {
          this.isRate = false;
          this.isRated = res.data;
        })
        .catch((r) => {
          console.log(r);
        });

      if (!this.currentVideo.video_id) {
        this.$message({
          type: "warning",
          message: "暂无视频！",
        });
        return;
      }

      // 获取播放权限
      let res = await this.$utils.get("/subject/lesson/getvideoauth", {
        vid: this.currentVideo.video_id,
      });
      if (res.data.success) {
				this.options.fileID = this.currentVideo.video_id;
				this.options.psign = res.data.data;
        // this.playAuth = res.data;
        // this.progressMarkers = [];
        // if (res.data.data.video_pop) {
        //   let data = {
        //     offset: JSON.parse(res.data.data.video_pop).offset,
        //     text: JSON.parse(res.data.data.video_pop).text,
        //     imgUrl: JSON.parse(res.data.data.video_pop).imgUrl,
        //   };
        //   this.progressMarkers.push(data);
        //   this.progressMarkers.push(
        //     ...JSON.parse(res.data.data.video_pop).domains
        //   );
        //   this.progressMarkers.forEach((element) => {
        //     element.isCustomized = true;
        //   });
        // }
        // console.log("this.progressMarkers", this.progressMarkers);
        this.isPlay = true;
      }
    },

    closeVideo() {
      // this.$refs.aliplayer.pause();
      this.isPlay = false;
    },
    checkChrome() {
      var isChrome = window.navigator.userAgent.indexOf("Chrome") > -1;
      if (!isChrome) {
        this.isChrome = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep
  .prism-player
  .prism-progress
  .prism-progress-marker
  .prism-marker-dot {
  width: 10px;
  height: 10px;
  margin-top: -3px;
  border-radius: 50%;
}

.mainPage {
  width: 100%;
  text-align: center;
  position: relative;
  min-height: 100%;
  background-color: #ebf0f9;
  background: linear-gradient(to bottom, #0d83c8, #d3e9f6);
  user-select: none;

  .agentTip {
    width: 100%;
    height: 70px;
    line-height: 70px;
    background-color: #ffe6a1;
    text-align: center;
    position: absolute;
    z-index: 5;
    color: #c40000;
  }

  .agentTip .closeTip {
    position: absolute;
    right: 24px;
    top: 0px;
    font-size: 30px;
    color: #282828;
    cursor: pointer;
  }

  .header_banner {
    position: relative;
    background-image: url(../img/iccb/banner_bg.png);
    height: 279px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;

    header {
      position: absolute;
      height: 50px;
      line-height: 50px;
      z-index: 2;
      // border-bottom: 1px solid rgba(#fff, 0.3);
      top: 0;
      width: 100%;
      margin: auto;
      color: #fff;

      .center {
        color: #8590cc;
        width: 1200px;
        margin: auto;

        a {
          color: #8590cc;
          margin-right: 15px;
          // opacity: 0.8;
        }
      }

      .left {
        float: left;
      }

      .right {
        float: right;
        // width: 100px;
        height: 30px;
        padding: 0 10px;
        margin-top: 30px;
        background-color: #ffffff;
        border-radius: 5px;

        img {
          vertical-align: text-top;
          margin-right: 15px;
        }

        .loginCon {
          line-height: 30px;

          span {
            cursor: pointer;
          }

          .username {
            // margin-right: 12px;
          }
        }
      }
    }

    .infoCon {
      .centerBg {
        width: 1414px;
        margin: auto;
        // position: absolute;
        // top: 25px;
        // left: 280px;
        // right: 0;

        .left {
          float: left;
          margin-top: 20px;
          margin-left: 5px;
        }

        .right {
          float: right;
        }
      }
    }
  }

  .content {
    display: flex;
    flex-direction: row;
    justify-content: center;
    max-width: 1400px;
    // height: 2860px;
    margin: auto;
    margin-top: 25px;

    .rightBox {
      width: 100%;
      display: flex;
      flex-direction: column;
      text-align: left;

      .classBox {
        width: 100%;
        .gallery-top {
          width: 100%;
          .slide {
            width: 100%;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            .leftImg {
              width: 800px;
              height: 500px;
            }
            .right {
              margin-left: 40px;
              .text1 {
                font-family: MicrosoftYaHei;
                font-size: 18px;
                color: #ffffff;
                margin-bottom: 20px;
              }
              .courseName {
                font-family: MicrosoftYaHei;
                font-weight: bold;
                font-size: 36px;
                line-height: 48px;
                color: #ffffff;
                margin-bottom: 30px;
              }
              .teacherName {
                font-family: MicrosoftYaHei;
                font-size: 20px;
                color: #ffffff;
                margin-bottom: 20px;
              }
              .courseDec {
                font-family: MicrosoftYaHei;
                font-size: 16px;
                line-height: 24px;
                color: #ffffff;
                opacity: 0.6;
              }
              .btnLearn {
                width: 130px;
                height: 40px;
                font-size: 18px;
                margin-top: 90px;
                background-color: #fff;
                border-radius: 10px;
                box-sizing: border-box;
                padding: 3px;
                color: #000;
                font-weight: 600;
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;

                img {
                  width: 17px;
                  height: 18px;
                  margin-right: 8px;
                }
              }
            }
          }
        }
        .gallery-thumbs {
          margin-top: 60px;
          .slide {
            width: 270px;
            opacity: 0.4;
            .courseImg {
              width: 266px;
              height: 166px;
            }
            .courseName {
              font-size: 14px;
              line-height: 18px;
              color: #282828;
            }
          }
          // .swiper-slide-prev {
          // 	transform: scale(0.9) !important;
          // 	transition-duration: .1s;
          // 	margin-left: -30px;
          // }
          // .swiper-slide-next {
          // 	transform: scale(0.9) !important;
          // 	transition-duration: .1s;
          // 	margin-right: 0px !important;
          // }
          .swiper-slide-active,
          .swiper-slide-duplicate-active {
            opacity: 1;
            transition-duration: 0.5s;
          }
          .swiper-button-prev,
          .swiper-button-next {
            margin-top: -40px;
          }
        }
      }
    }
  }

  .footer {
    height: 160px;
    display: flex;
    justify-content: center;
    align-items: center;

    .copy {
      width: 100%;
      font-weight: 600;
      color: #666;
    }
  }

  #videoPlayWrapper {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.8);
    z-index: 999;
    .videoContent {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      .closeVideo {
        position: absolute;
        right: 20px;
        top: 10px;
        font-size: 50px;
        color: #fff;
        cursor: pointer;
      }
      .videoContainer {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        // width: 1350px;
        // height: 760px;
        width: 76%;
        height: 90%;
        background: #000;
        z-index: 999999;
        video {
          width: 62%;
        }
      }
    }
  }

  #videoPlayWrapper
    .videoContainer
    video::-internal-media-controls-download-button {
    display: none;
  }

  video::-webkit-media-controls-enclosure {
    overflow: hidden;
  }

  video::-webkit-media-controls-panel {
    width: calc(100% + 30px);
  }

  #rateWrapper ::v-deep {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.8);
    z-index: 999;
    .rateContent {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      .closeRate {
        position: absolute;
        bottom: 150px;
        font-size: 50px;
        color: #fff;
        cursor: pointer;
      }
      .rateContainer {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 400px;
        height: 500px;
        background: #fff;
        border-radius: 20px;
        z-index: 999999;
        display: flex;
        flex-direction: column;
        align-items: center;
        .smile {
          width: 140px;
          height: fit-content;
          margin-top: -70px;
          // border-radius: 50%;
          // box-shadow: 0px 0px 20px 1px #fff;
        }

        .title {
          font-size: 40px;
          font-weight: bold;
          color: #0e79c0;
          margin-top: 40px;
        }
        .subTitle {
          font-size: 20px;
          color: #999;
          margin-top: 23px;
        }

        .text {
          font-size: 20px;
          color: #333;
          margin-top: 34px;
          margin-bottom: 10px;
        }
        .text2 {
          font-size: 20px;
          color: #333;
          margin-top: 10px;
          margin-bottom: 10px;
        }

        .el-rate {
          height: 36px;
        }
        .el-rate__icon {
          font-size: 36px;
        }

        .btnBox {
          margin-top: 30px;

          .btn {
            background-image: linear-gradient(
              45deg,
              #0e79c0 0%,
              #099fdc 51%,
              #0e79c0 100%
            );
          }

          .btn {
            width: 200px;
            margin: 10px;
            padding: 15px 30px;
            font-size: 20px;
            text-align: center;
            text-transform: uppercase;
            transition: 0.5s;
            background-size: 200% auto;
            color: white;
            border-radius: 100px;
            display: block;
            border: 0px;
            font-weight: bold;
            box-shadow: 0px 0px 14px -7px #f09819;
            cursor: pointer;
          }

          .btn:hover {
            background-position: right center;
            /* change the direction of the change here */
            color: #fff;
            text-decoration: none;
          }

          .btn:active {
            transform: scale(0.95);
          }
        }
      }
    }
  }

  #tipsWrapper ::v-deep {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.8);
    z-index: 999;
    .rateContent {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      .closeRate {
        position: absolute;
        bottom: 270px;
        font-size: 50px;
        color: #fff;
        cursor: pointer;
      }
      .rateContainer {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        padding: 20px;
        width: 500px;
        height: 225px;
        background: #fff;
        border-radius: 20px;
        z-index: 999999;
        display: flex;
        flex-direction: column;
        align-items: center;
        .smile {
          width: 140px;
          height: fit-content;
          margin-top: -70px;
          // border-radius: 50%;
          // box-shadow: 0px 0px 20px 1px #fff;
        }

        .title {
          font-size: 30px;
          font-weight: bold;
          color: #0e79c0;
          margin-top: 10px;
        }
        .subTitle {
          font-size: 20px;
          color: #999;
          margin-top: 23px;
        }

        .text {
          font-size: 20px;
          color: #333;
          margin-top: 25px;
          line-height: 25px;
          margin-bottom: 10px;
        }
        .text2 {
          font-size: 20px;
          color: #333;
          margin-top: 10px;
          margin-bottom: 10px;
        }

        .btnBox {
          margin-top: 10px;
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          .btn {
            background-image: linear-gradient(
              45deg,
              #0e79c0 0%,
              #099fdc 51%,
              #0e79c0 100%
            );
          }

          .btn {
            width: 130px;
            margin: 10px;
            padding: 15px 30px;
            font-size: 20px;
            text-align: center;
            text-transform: uppercase;
            transition: 0.5s;
            background-size: 200% auto;
            color: white;
            border-radius: 100px;
            display: block;
            border: 0px;
            font-weight: bold;
            box-shadow: 0px 0px 14px -7px #f09819;
            cursor: pointer;
          }

          .btn:hover {
            background-position: right center;
            /* change the direction of the change here */
            color: #fff;
            text-decoration: none;
          }

          .btn:active {
            transform: scale(0.95);
          }
        }
      }
    }
  }

  // // 110%
  // @media screen and (max-width: 1750px) {

  // 	.mainPage .header_banner {
  // 		height: 560px;
  // 	}

  // 	.mainPage .content .rightBox .classBox .swiper_con {

  // 		.swiper {
  // 			.swiper-slide {
  // 				width: 4rem !important;

  // 				.video_con {
  // 					width: 4rem;

  // 					.video_cover {
  // 						width: 4rem;
  // 						height: calc(4rem/ (16/9));
  // 					}
  // 				}
  // 			}
  // 		}

  // 		.swiper-button-next[data-v-5f9973b2] {
  // 			right: -60px;
  // 		}

  // 	}

  // 	.mainPage .footer{
  // 		margin-top: -360px;
  // 		.copy {
  // 			bottom: 100px;
  // 		}
  // 	}

  // }

  // // 125%
  // @media screen and (max-width: 1540px) {

  // 	.mainPage .header_banner {
  // 		height: 540px;
  // 	}

  // 	.mainPage .content .rightBox .classBox .swiper_con {

  // 		.swiper {
  // 			.swiper-slide {
  // 				width: 4.5rem !important;

  // 				.video_con {
  // 					width: 4.5rem;

  // 					.video_cover {
  // 						width: 4.5rem;
  // 						height: calc(4.3rem/ (16/9));
  // 					}
  // 				}
  // 			}
  // 		}

  // 		.swiper-button-next[data-v-5f9973b2] {
  // 			right: -60px;
  // 		}

  // 	}

  // 	.mainPage .footer {
  // 		margin-top: -400px;
  // 	}

  // }

  // // 150%
  // @media screen and (max-width: 1280px) {

  // 	.mainPage .header_banner {
  // 		height: 410px;
  // 	}

  // 	.mainPage .content .rightBox .classBox .swiper_con {

  // 		.swiper {
  // 			.swiper-slide {
  // 				width: 5rem !important;

  // 				.video_con {
  // 					width: 5rem;

  // 					.video_cover {
  // 						width: 5rem;
  // 						height: calc(4.7rem/ (16/9));
  // 					}
  // 				}
  // 			}
  // 		}

  // 		.swiper-button-next[data-v-5f9973b2] {
  // 			right: -60px;
  // 		}

  // 	}

  // 	.mainPage .header_banner .infoCon .centerBg {
  // 		transform: scale(0.7);
  // 		top:-20px;
  // 		left: 130px;
  // 	}

  // 	.projectProfile {
  // 		transform: scale(0.9);
  // 		margin-left: -100px;
  // 	}

  // 	.mainPage .content {
  // 		.leftBox {
  // 			transform: scale(0.9);
  // 			left: -50px;
  // 			top: 0;
  // 		}

  // 		.rightBox {
  // 			transform: scale(0.9);
  // 			margin-top: -140px;
  // 			margin-left: 70px;

  // 		}

  // 		// height: 3000px;
  // 		// transform: scale(0.8);
  // 	}
}
</style>
